module.exports = __webpack_public_path__ + "static/media/imgBannerPrincipalHome.8db2a644.svg";